import React from "react";
import AboutUs from "../../components/landingPageComponent/AboutUs";
import Clients from "../../components/landingPageComponent/Clients";
import ContactForm from "../../components/landingPageComponent/ContactForm";
import Faqs from "../../components/landingPageComponent/Faqs";
import Footer from "../../components/landingPageComponent/Footer";
import Hero from "../../components/landingPageComponent/Hero";
import Navbar from "../../components/landingPageComponent/Navbar";
import HowItWorks from "../../components/landingPageComponent/HowItWorks";
import ScrollTop from "../../components/landingPageComponent/ScrollTop";
import ProductsAndServices from "../../components/landingPageComponent/ProductsAndServices";
import Pricing from "../../components/landingPageComponent/Pricing";

const Home = () => {
  return (
    <div className="overflow-hidden">
      <Navbar />
      <Hero />
      <AboutUs />
      <ProductsAndServices />
      <br />
      <HowItWorks />
      <Pricing />
      <Clients />
      <Faqs />
      <ContactForm />
      <Footer />
      <ScrollTop />
    </div>
  );
};

export default Home;
